module.exports = __webpack_public_path__ + "img/logo.b008918f.svg";